import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminListingsApi as n } from "@maat/api-main";
//#region src/listings/admin/useAdminListingQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.getListing(r),
	enabled: !!r
});
//#endregion
export { r as useAdminListingQuery };
